import { memo } from "react";

import { getURL } from "@/lib/aws-amplify/storage";
import type { S3Object } from "@/lib/gql/__generated__/graphql";

import { RoundedFullButton } from "@/components/ui/button/rounded-full-button";
import { Image } from "@/components/ui/image/image";

type Props = {
	items: S3Object[];
	handleClick: (item: S3Object) => void;
};

export const PreviewItems = memo(({ items, handleClick }: Props) => {
	return (
		Boolean(items?.length) && (
			<div className="grid grid-cols-4 gap-x-2 gap-y-4">
				{items.map((item, index) => {
					const url = getURL(item);

					return (
						<div key={url} className="relative col-span-1 max-h-[fit-content]">
							<div role="button" className="absolute right-3 top-2 h-4 w-4">
								<RoundedFullButton onClick={() => handleClick(item)} />
							</div>
							<Image
								src={url}
								alt={`key_visual_${index}`}
								className="h-fit w-full max-w-sm rounded border border-zinc-200 object-contain"
							/>
						</div>
					);
				})}
			</div>
		)
	);
});
